import { createSlice } from "@reduxjs/toolkit"

const INITIAL_STATE = {
  pendingToasts: [], // Array of toast objects: { id, type, message, messageId, values }
}

const toastSlice = createSlice({
  name: "toast",
  initialState: INITIAL_STATE,
  reducers: {
    addToast: (state, action) => {
      const { type, message, messageId, values } = action.payload
      const toast = {
        id: Date.now() + Math.random(), // Simple unique ID
        type, // 'success', 'error', 'info', 'warning'
        message,
        messageId, // For react-intl formatted messages
        values, // For react-intl message values
        timestamp: Date.now(),
      }
      state.pendingToasts.push(toast)
    },
    
    removeToast: (state, action) => {
      const toastId = action.payload
      state.pendingToasts = state.pendingToasts.filter(toast => toast.id !== toastId)
    },
    
    clearToast: (state, action) => {
      const toastId = action.payload
      state.pendingToasts = state.pendingToasts.filter(toast => toast.id !== toastId)
    },
    
    clearAllToasts: (state) => {
      state.pendingToasts = []
    },
    
    // Convenience actions for common toast types
    addSuccessToast: (state, action) => {
      const { message, messageId, values } = action.payload
      const toast = {
        id: Date.now() + Math.random(),
        type: 'success',
        message,
        messageId,
        values,
        timestamp: Date.now(),
      }
      state.pendingToasts.push(toast)
    },
    
    addErrorToast: (state, action) => {
      const { message, messageId, values } = action.payload
      const toast = {
        id: Date.now() + Math.random(),
        type: 'error',
        message,
        messageId,
        values,
        timestamp: Date.now(),
      }
      state.pendingToasts.push(toast)
    },
    
    addInfoToast: (state, action) => {
      const { message, messageId, values } = action.payload
      const toast = {
        id: Date.now() + Math.random(),
        type: 'info',
        message,
        messageId,
        values,
        timestamp: Date.now(),
      }
      state.pendingToasts.push(toast)
    },
  },
})

export const {
  addToast,
  removeToast,
  clearToast,
  clearAllToasts,
  addSuccessToast,
  addErrorToast,
  addInfoToast,
} = toastSlice.actions

export default toastSlice.reducer